var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.862,
    height: 20.234,
    viewBox: "0 0 16.862 20.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash_2_",
    "data-name": "trash (2)",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15606",
    "data-name": "Path 15606",
    d: "M18.019,3.372H15.405A4.223,4.223,0,0,0,11.274,0H9.588A4.223,4.223,0,0,0,5.457,3.372H2.843a.843.843,0,0,0,0,1.686h.843v10.96A4.221,4.221,0,0,0,7.9,20.234H12.96a4.221,4.221,0,0,0,4.215-4.215V5.059h.843a.843.843,0,0,0,0-1.686ZM9.588,1.686h1.686a2.534,2.534,0,0,1,2.385,1.686H7.2A2.534,2.534,0,0,1,9.588,1.686Zm5.9,14.333a2.529,2.529,0,0,1-2.529,2.529H7.9a2.529,2.529,0,0,1-2.529-2.529V5.059H15.49Z",
    fill: "#ff6036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15607",
    "data-name": "Path 15607",
    d: "M9.843,16.745a.843.843,0,0,0,.843-.843V10.843a.843.843,0,0,0-1.686,0V15.9A.843.843,0,0,0,9.843,16.745Z",
    transform: "translate(-1.098 -1.569)",
    fill: "#ff6036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15608",
    "data-name": "Path 15608",
    d: "M13.843,16.745a.843.843,0,0,0,.843-.843V10.843a.843.843,0,0,0-1.686,0V15.9A.843.843,0,0,0,13.843,16.745Z",
    transform: "translate(-1.726 -1.569)",
    fill: "#ff6036"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.342dff935917e9a1e2beab88c4de2ac7.svg";
export { ForwardRef as ReactComponent };